import { faTimes, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import './PortfolioText.module.scss';
import { EvidenceState } from 'typings';
import updateEvidence from 'actions/evidence/update';
import { useTranslate } from 'hooks/useTranslate';
import { Translate } from 'react-localize-redux';
import { useDispatch } from 'react-redux';

export default function PortfolioText({
  evidence,
  handleDelete,
}: {
  evidence: EvidenceEntity;
  handleDelete?: (c: EvidenceState) => void;
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(evidence?.metadata?.title);
  const [text, setText] = useState(evidence?.metadata?.text);

  const dispatch = useDispatch();
  const translate = useTranslate();

  const saveEdit = () => {
    console.log('save edit');
    dispatch(
      updateEvidence({
        ...evidence,
        metadata: {
          text,
          title,
        },
      })
    ).then(() => {
      setIsEditing(false);
    });
  };

  useEffect(() => {
    if (evidence.created_at === evidence.updated_at) {
      setIsEditing(true);
    }
  }, []);

  return (
    <div styleName={`portfolio-text ${isEditing ? 'editing' : ''}`}>
      <div styleName="top-icons">
        {!!handleDelete && (
          <>
            {isEditing ? (
              <FontAwesomeIcon onClick={saveEdit} icon={faCheck} />
            ) : (
              <FontAwesomeIcon
                styleName="pen"
                onClick={() => setIsEditing(!isEditing)}
                icon={faPen}
              />
            )}
            <FontAwesomeIcon
              onClick={() => {
                handleDelete({
                  evidenceId: evidence.id,
                  path: '',
                  name: '',
                });
              }}
              icon={faTimes}
            />
          </>
        )}
      </div>
      <input
        disabled={!isEditing}
        value={title}
        onChange={(e) => setTitle(e?.target.value)}
        type="text"
        placeholder={translate('general.terms.title') as string}
      />
      <textarea
        disabled={!isEditing}
        value={text}
        onChange={(e) => setText(e?.target.value)}
        placeholder={translate('general.terms.description') as string}
      />
    </div>
  );
}
